export class ChangeRequestTypes {
  ChangeRequestTypeID: number;
  ChangeRequestType: string;
  Status: boolean;
}
